const API_BASE_PATH = 'https://api.kopiketjil.com/api'
const API_KOPI_KETJIL = API_BASE_PATH + '/kopiketjil'

export default {
  api: {
    kopi_ketjil: {
      users: API_KOPI_KETJIL + '/users',
      posts: API_KOPI_KETJIL + '/post',
      carts: API_KOPI_KETJIL + '/cart',
      wishlists: API_KOPI_KETJIL + '/wishlist',
      categories: API_KOPI_KETJIL + '/category',
      traceability: API_KOPI_KETJIL + '/traceability',
      galleries: API_KOPI_KETJIL + '/gallery',
      products: API_KOPI_KETJIL + '/product',
      transactions: API_KOPI_KETJIL + '/transaction',
      videos: API_KOPI_KETJIL + '/video',
      user: API_KOPI_KETJIL + '/user',
      login: API_KOPI_KETJIL + '/login',
      logout: API_KOPI_KETJIL + '/logout',
      register: API_KOPI_KETJIL + '/register',
      franchise: API_KOPI_KETJIL + '/franchise',
      product_category: API_KOPI_KETJIL + '/product-category',
      regions: API_KOPI_KETJIL + '/region',
      outlets: API_KOPI_KETJIL + '/outlet',
      forgot_password: API_KOPI_KETJIL + '/forgot-password',
      validate_key: API_KOPI_KETJIL + '/validate-key',
      change_password: API_KOPI_KETJIL + '/change-password'
    }
  },
  app: {
    pages: {
      users: '/users'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config.js